import configureGoogleAnalytics4 from './configureGoogleAnalytics4';
import getStorageAPIValue from './getStorageAPIValue';

const googleAnalytics4 = (measurementId, isChat) => {
    configureGoogleAnalytics4(measurementId);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }
    gtag('js', new Date());

    // don't send page view event when we load the gtag script
    gtag('config', measurementId, { send_page_view: false });

    if (isChat) {
        if (getStorageAPIValue('livechat_ga4_chat_logged') != 'true') {
            gtag('event', 'chatStart', { send_to: measurementId });
            ApexChat.storageAPI.Store('livechat_ga4_chat_logged', true);
        }
    } else if (getStorageAPIValue('livechat_ga4_lead_logged') != 'true') {
        gtag('event', 'chatLead', { send_to: measurementId });
        ApexChat.storageAPI.Store('livechat_ga4_lead_logged', true);
    }
};
export default googleAnalytics4;
